import { themr } from '@friendsofreactjs/react-css-themr';
import Error from './Error';

export default themr('Error')(Error);
